module.exports = __webpack_public_path__ + "img/cancel.d1664a1f.png";